import { render, staticRenderFns } from "./InstableFlock.vue?vue&type=template&id=a138343e&"
import script from "./InstableFlock.vue?vue&type=script&lang=js&"
export * from "./InstableFlock.vue?vue&type=script&lang=js&"
import style0 from "./InstableFlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports